var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ImagePairsTrial',{attrs:{"displaySeconds":_vm.displaySeconds},on:{"answered":_vm.handleResponse}})}
var staticRenderFns = []

export { render, staticRenderFns }